import { useEffect, useRef } from 'react';

interface UseAutoOpenOrderDetailsCameraParams {
  readonly sessionKey: string;
  readonly loading: boolean;
  readonly enabled: boolean;
  readonly itemCount: number;
  readonly allPickLinesScanned: boolean;
  readonly isSubmitted: boolean;
  readonly setWebcamOn: (on: boolean) => void;
}

/** Opens the pick-page camera once per work order when Configure "Open camera in Order Details" is on. */
export function useAutoOpenOrderDetailsCamera({
  sessionKey,
  loading,
  enabled,
  itemCount,
  allPickLinesScanned,
  isSubmitted,
  setWebcamOn,
}: UseAutoOpenOrderDetailsCameraParams): void {
  const autoOpenedForKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (autoOpenedForKeyRef.current !== sessionKey) {
      autoOpenedForKeyRef.current = null;
    }
    if (loading || !enabled || itemCount === 0) return;
    if (autoOpenedForKeyRef.current === sessionKey) return;
    autoOpenedForKeyRef.current = sessionKey;
    if (allPickLinesScanned || isSubmitted) return;
    setWebcamOn(true);
  }, [
    sessionKey,
    loading,
    enabled,
    itemCount,
    allPickLinesScanned,
    isSubmitted,
    setWebcamOn,
  ]);
}
